import React from 'react'
import loadable from '@loadable/component'
// Components
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
//import {routes as _routes} from '@salesforce/retail-react-app/app/routes'
const fallback = <Skeleton height="75vh" width="100%" />
const LeftNavLayout = loadable(() => import('./components/left-nav-layout'), {fallback})
const LeftNav = loadable(() => import('./components/left-nav'), {fallback})

// Support Content pages
const SizingGuide = loadable(() => import('./pages/content/support/sizing-guide/index'), {fallback})
const Shipping = loadable(() => import('./pages/content/support/shipping/index'), {fallback})
const ReturnsExchanges = loadable(() => import('./pages/content/support/returns-exchanges/index'), {
    fallback
})
const CandidatePrivacyNotice = loadable(
    () => import('./pages/content/support/candidate-privacy-notice/index'),
    {fallback}
)
const AccessibilityPolicy = loadable(
    () => import('./pages/content/support/accessibility-policy/index'),
    {fallback}
)
const Promotions = loadable(() => import('./pages/content/promotions'), {fallback})
const SiteMap = loadable(() => import('./pages/content/sitemap'), {fallback})
const Terms = loadable(() => import('./pages/content/support/terms'), {fallback})
const PrivacyPolicy = loadable(() => import('./pages/content/support/privacy-policy'), {fallback})
const ContentWithToggleNav = loadable(() => import('./pages/content/content-left-nav'), {fallback})

const SizeGuide = () => (
    <ContentWithToggleNav contentPath="content/size-guide" Component={SizingGuide} />
)

const ShippingInformation = () => (
    <ContentWithToggleNav contentPath="content/ordering-information" Component={Shipping} />
)

const Returns = () => (
    <ContentWithToggleNav contentPath="content/returns-exchanges" Component={ReturnsExchanges} />
)

const PrivacyNotice = () => (
    <ContentWithToggleNav
        contentPath="content/Candidate-Privacy-Notice"
        Component={CandidatePrivacyNotice}
    />
)

const Accessibility = () => (
    <ContentWithToggleNav contentPath="content/footer-ada-policy" Component={AccessibilityPolicy} />
)

const SiteMapPage = () => (
    <LeftNavLayout sidebar={<LeftNav />}>
        <SiteMap />
    </LeftNavLayout>
)

const TermsPage = () => <ContentWithToggleNav contentPath="content/terms" Component={Terms} />

const PrivacyPolicyPage = () => (
    <ContentWithToggleNav contentPath="content/privacy-policy" Component={PrivacyPolicy} />
)

const SupportRoutes = [
    {
        path: '/content/size-guide.html',
        component: SizeGuide,
        exact: true
    },
    {
        path: '/content/ordering-information.html',
        component: ShippingInformation,
        exact: true
    },
    {
        path: '/content/returns-exchanges.html',
        component: Returns,
        exact: true
    },
    {
        path: '/content/Candidate-Privacy-Notice.html',
        component: PrivacyNotice,
        exact: true
    },
    {
        path: '/content/footer-ada-policy.html',
        component: Accessibility,
        exact: true
    },
    {
        path: '/sitemap',
        component: SiteMapPage,
        exact: true
    },
    {
        path: '/promotions',
        component: Promotions,
        exact: true
    },
    {
        path: '/content/terms.html',
        component: TermsPage,
        exact: true
    },
    {
        path: '/content/privacy-policy.html',
        component: PrivacyPolicyPage,
        exact: true
    }
]

export default SupportRoutes
